import { Component, Prop, Vue } from 'vue-property-decorator';
import WithRender from './ViewPage.html';
import '../../assets/modify.css';
import '../../assets/timeline.css';
import { Inject } from 'vue-di-container';
import DialogComponent from '@/components/DialogComponent.vue';
import MemoryService, { StateMessage } from '@/Services/MemoryService';

import { mask } from 'vue-the-mask';

import { Toaster } from '@/Services/toast';
import GStatic from '../../Services/GStatic';
import MortgagesService from '../../Services/MortgagesService';
//import AprroveRejectMortgages from '@/Models/AprroveRejectMortgages';

type VerifyState = 'OK' | 'WAITING' | 'EXPIRED' | 'ERROR';
type VerifyResult = { success: boolean; state: VerifyState; message?: string };

@WithRender
@Component({
    components: {
        DialogComponent
    },
    directives: {
        mask
    },
    diProvide: [
        MortgagesService
    ],
})

export default class ViewPage extends Vue {
    @Inject(MortgagesService) public mortgagesService!: MortgagesService;
    @Inject(MemoryService) public memoryService!: MemoryService;

    public isDataValid = false;
    public isLoading = false;
    public requestFinished = false;
    public timelineDetailed = true;
    public alertText: string = '';
    public dataItem: any = {};
    public dataItems: any = {};
    public timeToExpire = '';
    public TopItem: any = {};
    public cancelreasons: any = {};
    public otpExpireTimer: any = {};
    public resonTex = "";
    public errorMessage: StateMessage = { type: 'warning', body: '', title: '' };


    public QaimHeader: string = ''
    public QaimFooter: string = ''
    public QaimSurveyID: any
    public QaimFirstName: any
    public QaimLastName: any
    public QaimBirthDate: any
    public QaimNationalityNumber: any
    public QaimNationalityId: any
    public QaimusrGender: any
    public QaimresponseSentToUrl: any
    /*  public openRating: boolean = false*/
    public ShowQaim: boolean = false
    public QaimConfig: any
    public objResult = "";

    public canApproveRejectMortgages: boolean = false;
    public canCompleteMortgages: boolean = false;
    public canSendCompleteMortgagesRequest: boolean = false;
    public canApproveRejectCompleteMortgagesRequest: boolean = false;
    public checked: boolean = false;
    public isAnnoymousUser = false;
    public checkuser: boolean = false;
    public showCancellationReasonDiv: boolean = false;
    public showOTPDiv: boolean = false;
    public showNafathDiv: boolean = false;
    public nafathErrorMessage: string = '';
    public isPollingActive = false
    public IsNafathAuthenticationEnabled: boolean = false;
    public nafathCode: number = 0;
    public pollingInterval: any = null;
    public pollingStartTimeout: any = null;



    public otpExpirationTime: number = 0;
    public openCloseDialog: boolean = false;
    public openStep: string = '';
    public messageAlert: string = '';
    public otpCode: string = '';
    public otpTimeOut: Date | null = null;
    public otpError: string = '';
    public wrongOtp: string = '';
    public approveMortgagesResult: any = {};
    public cancellationReasons: any[] = [];
    public selectedCancellationReasonObj = {};
    public otpCodeArray: any[] = [, , , ,]
    public checkedcancelationDetails: boolean = false;
    public showCancelationDetails: boolean = false;
    public selectedCancellationReason: number = 0;
    public cancelationDetails: string = '';
    public disableSendCancelationOTPButton: boolean = true;

    public eId: string = '';
    public eKey: string = '';
    public eIdNo: any = '';
    public eReqType: any = '';

    public userflag: boolean = false;
    //public isNajizUser: boolean = false;
    public getheader: any[] = [];
    public mortgage: any = {};
    public viewButton: boolean = false;
    public disableResend: boolean = true;
    public verifyclick: number = 0;
    public showUpdateSuccessResult: boolean = false;

    @Prop({ type: String, default: '' }) public EId !: string;
    @Prop({ type: String, default: '' }) public EKey !: string;
    @Prop({ type: String, default: '' }) public EIdNo !: string;
    @Prop({ type: String, default: '' }) public EReqType !: string;


    public get trackingList() {
        let list: any = {
            doneUsers: [],
            pendingUsers: []
        }
        list.pendingUsers = this.dataItem.listMortgagor.filter((item: any) => item.MortgagorActionText === "في انتظار الاعتماد")


        // this.dataItem.RequestHistoryLogs.shift()
        this.dataItem.RequestHistoryLogs.forEach((logItem: any) => {
            let comparison = this.dataItem.listMortgagor.filter((item: any) => item.Mortgagor.IdentityNumber === logItem.IdentityNumber)

            if (comparison) {
                let mutatedArr = comparison.map((item: any) => {
                    return {
                        ActionHijriDate: logItem.ActionHijriDate,
                        Action: logItem.Action,
                        ActionText: logItem.ActionText,
                        ActionedByName: logItem.ActionedByName,
                        ...item
                    }
                })
                list.doneUsers.push(...mutatedArr)

            }
        })
        return list
    }
    public get mortegorsCasuingCanecllation() {
        return this.dataItem.listMortgagor.filter((item: { IsPersonCausingCancellation: any; }) => item.IsPersonCausingCancellation)
    }
    public get isMortgageIssued() {
        return this.dataItem.Status == 3 || this.dataItem.Status == 4;
    }


    public get isMortgageCanceled(): boolean {
        return this.dataItem.Status == 6;
    }
    public get isMortgageExpired(): boolean {
        return this.dataItem.Status == 4
    }
    public get isDocumentOrRequest(): boolean {
        return this.dataItem && this.dataItem.DocumentNumber;
    }
    public async mounted() {

        this.eId = this.EId ? this.EId : '';
        this.eKey = this.EKey ? this.EKey : '';
        if (this.eId != '' && this.eKey != '') {
            this.eIdNo = this.$route.query.IdNo;
            this.eReqType = this.$route.query.ReqType
            require('@/assets/adminAnnoymous.css');
            await this.fillDataByIdAndKey(this.eId, this.eKey, this.eReqType);
            this.isAnnoymousUser = true;
            this.IsNafathAuthenticationEnabled = await this.GetNafathSettings();
        }
        else {
            await this.fillData();
        }
        await window.scrollTo(0, 0);
    }
    public async fillData() {
        this.isLoading = true;
        const type = String(this.$route.params.id).substring(String(this.$route.params.id).length - 1)
        const id = String(this.$route.params.id).substring(0, String(this.$route.params.id).length - 1)
        console.log(id, type, 'dasdas')
        const response = await this.mortgagesService.GetMortgageById(parseInt(id), parseInt(type));
        this.IsNafathAuthenticationEnabled = await this.GetNafathSettings();
        //console.log(this.IsNafathAuthenticationEnabled, ' IsNafathAuthenticationEnabledw')
        //debugger;
        let parsedResponse = JSON.parse(response![0])
        console.log(parsedResponse)
        this.isLoading = false;
        if (parsedResponse.isError) {
            this.isDataValid = false;
        }
        else {
            this.isDataValid = true;
            this.dataItem = { ...parsedResponse.result, requesterId: response![1] };
        }
        this.canApproveRejectMortgages = this.dataItem.Status === 2;
        this.dataItem.RequestHistoryLogs.filter((i: any) => i.IdentityNumber === response![1]).length ? this.canApproveRejectMortgages = false : ''
    }

    public GetHaizDisplayText(mortgageItem: any) {
        // حائز ولا يحق له الانتفاع 
        // لايحق له الانتفاع
        // حائز ويحق له الانتفاع ,

        let retValue = '';

        if (mortgageItem.IsPersonHaiz && mortgageItem.IsPersonEntitled)
            retValue = ' يحق للحائز الانتفاع بالرهن';
        if (mortgageItem.IsPersonHaiz && mortgageItem.IsPersonEntitled == false)
            retValue = 'لا يحق للحائز الانتفاع بالرهن';
        if (mortgageItem.IsPersonHaiz == false && mortgageItem.IsPersonEntitled == false)
            retValue = 'لا يحق للحائز الانتفاع بالرهن';
        return retValue;
    }
    public async fillDataByIdAndKey(Id: string, Key: string, type: any) {
        this.isLoading = true;
        const response = await this.mortgagesService.GetMortgageByIdAndKey(Id, Key, type);
        this.isLoading = false;
        if (response.isError || response.result.json == null) {
            this.isDataValid = false;
        }
        else {
            this.isDataValid = true;
            this.dataItem = response.result.json;
        }

        this.canApproveRejectMortgages = this.dataItem.Status === 2;
    }
    public convertDate(date: any) {
        return GStatic.convertDateToFront(date.toString());
    }
    public async ApproveRejectwithOTP(event: string) {
        console.log(this.eId, 'daraaa')

        if (this.checked == false && event == 'ApproveMortgages') {
            Toaster.error('عذراً، يجب الموافقة على الإقرار لتتمكن من إكمال قبول الطلب واعتماده');

            return;
        }
        this.openStep = event;
        this.otpCode = "";

        if (event == 'RejectMortgages') {
            const cancelreasons = await this.mortgagesService.CancellationReasons();
            this.cancellationReasons = cancelreasons.result;

            this.openCloseDialog = true;
            this.showCancellationReasonDiv = true;
            this.showOTPDiv = false;
            this.showNafathDiv = false;
            this.nafathErrorMessage = '';

        }
        else {
            let aproveData = {
                Key: encodeURIComponent(this.eKey),
                IdNo: String(encodeURIComponent(this.eIdNo)).trim(),
                Id: encodeURIComponent(this.eId),
                MortgageId: String(this.dataItem.MortgageRequestId),
                //Flag: event == 'RejectMortgages' ? '3' : 
            }
            //const otpResponse = await this.mortgagesService.GenerateOtp(aproveData);  // Send OTP through API.
            const otpResponse = this.IsNafathAuthenticationEnabled ? await this.mortgagesService.NafathGenerateOtp(aproveData) : await this.mortgagesService.GenerateOtp(aproveData);  // Send OTP through API.
            console.log(otpResponse, "NafathGenerateOtpres");

            // this.IsNafathAuthenticationEnabled ? this.nafathCode = Number(otpResponse.result.random) : 0;
            if (this.IsNafathAuthenticationEnabled) {
                this.nafathCode = (otpResponse && otpResponse.result && otpResponse.result.random)
                    ? Number(otpResponse.result.random)
                    : 0;
            }


            if (otpResponse == undefined || (otpResponse.isError && otpResponse.isError == true)) {
                this.openCloseDialog = false;
                Toaster.error(otpResponse.responseException);
            }
            else {

                this.openCloseDialog = true;
                this.showCancellationReasonDiv = false;
                this.nafathErrorMessage = '';

                //this.showOTPDiv = true;

                const nafathEnabled = Boolean(this.IsNafathAuthenticationEnabled);
                //console.log(this.IsNafathAuthenticationEnabled, "IsNafathAuthenticationEnabled");

                if (nafathEnabled) {
                    this.showNafathDiv = true;
                    this.showOTPDiv = false;
                    //if (this.pollingInterval) { clearInterval(this.pollingInterval); this.pollingInterval = null; }

                    //this.startPollingNafathVerifyOTP();
                    this.nafathErrorMessage = '';
                    this.stopPolling();           // just in case
                    this.startPollingNafathVerifyOTP();

                } else {
                    this.showNafathDiv = false;
                    this.showOTPDiv = true;
                    this.otpExpirationTime = new Date().getTime() + 2 * 60000;
                    this.runOTPExpirationTimer();

                    let thisPage = this;
                    setTimeout(function () {
                        thisPage.disableResend = false;
                    }, 120000);

                    setTimeout(() => {
                        //@ts-ignore
                        thisPage.$refs.txtOtpCode.focus();
                    });
                }

            }
        }
    }

    public async sendCancelationOTP() {
        if (this.showCancelationDetails) {
            if (this.cancelationDetails == '') {
                Toaster.error('رجاء ادخال البيانات الناقصة في الطلب');
                return;
            }
            const exp = /^(?:[a-zA-Z0-9\s,.\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF])){0,500}$/;
            if (!exp.test(this.cancelationDetails.trim())) {
                Toaster.error('يوجد خطأ في البيانات المدخلة، الرجاء التحقق من ادخال البيانات بشكل صحيح.');
                return;
            }
        }

        const aproveData = {
            Key: this.eKey,
            IdNo: String(this.eIdNo).trim(),
            Id: this.eId,
            MortgageId: String(this.dataItem.MortgageRequestId)
        };

        const nafathEnabled = Boolean(this.IsNafathAuthenticationEnabled);

        const otpResponse = nafathEnabled
            ? await this.mortgagesService.NafathGenerateOtp(aproveData)
            : await this.mortgagesService.GenerateOtp(aproveData);

        console.log('sendCancelationOTP response:', otpResponse);

        if (!otpResponse || (otpResponse.isError && otpResponse.isError === true)) {
            this.openCloseDialog = false;
            /* Toaster.error(otpResponse?.responseException || 'تعذر إرسال رمز التحقق');*/
            Toaster.error(
                (otpResponse && otpResponse.responseException)
                    ? otpResponse.responseException
                    : 'تعذر إرسال رمز التحقق'
            );

            return;
        }

        // Common dialog state after sending
        this.showCancellationReasonDiv = false;
        this.openCloseDialog = true;
        this.nafathErrorMessage = '';

        if (nafathEnabled) {
            // ---- Nafath path ----
            this.showNafathDiv = true;
            this.showOTPDiv = false;

            this.nafathCode = (otpResponse && otpResponse.result && otpResponse.result.random)
                ? Number(otpResponse.result.random)
                : 0;

            this.stopPolling();            // safety
            this.startPollingNafathVerifyOTP();
        } else {
            // ---- OTP path ----
            this.showNafathDiv = false;
            this.showOTPDiv = true;

            this.disableResend = true;
            this.otpExpirationTime = new Date().getTime() + 2 * 60000;
            this.runOTPExpirationTimer();
            setTimeout(() => (this.disableResend = false), 120000);

            //this.$nextTick(() => {
            //    // @ts-ignore
            //    this.$refs.txtOtpCode?.focus?.();
            //});
            this.$nextTick(() => {
                const ref: any = (this.$refs as any).txtOtpCode;
                if (ref && typeof ref.focus === 'function') ref.focus();
            });
        }
    }

    public closeDialog() {
        this.stopPolling();
        this.openCloseDialog = false;
        this.showCancellationReasonDiv = false;
        this.showOTPDiv = false;
        this.showNafathDiv = false;
        this.nafathErrorMessage = '';
        if (this.otpExpireTimer) {
            clearInterval(this.otpExpireTimer);
            this.otpExpireTimer = null;
        }


    }
    beforeDestroy() {
        this.stopPolling();
        if (this.otpExpireTimer) {
            clearInterval(this.otpExpireTimer);
            this.otpExpireTimer = null;
        }
    }



    public onSelectedCancelReasonChange(evt: any) {
        if (evt.target.value)
            this.disableSendCancelationOTPButton = false;
        else
            this.disableSendCancelationOTPButton = true;

        this.showCancelationDetails = false;
        this.cancelationDetails = '';
        this.selectedCancellationReason = evt.target.value; //.Id;
        /*    console.log(this.selectedCancellationReason, 'value')*/
        let isDetailRequired = this.cancellationReasons.find((cr) => cr.Id == this.selectedCancellationReason);//[0].IsCancellationDetailsRequired;
        if (isDetailRequired)
            this.showCancelationDetails = isDetailRequired.IsCancellationDetailsRequired;//evt.IsCancellationDetailsRequired;
    }

    public async VerifyOTP() {
        if (this.verifyclick == 2) {
            this.disableResend = false;
        }
        let verifyRequest = {
            otp: this.otpCode,
            Decision: this.openStep,
            encId: this.eId,
            encKey: this.eKey,
            encIdNo: String(this.eIdNo).trim(),
            MortgageId: String(this.dataItem.MortgageRequestId),

            cancelReason: this.selectedCancellationReason,
            cancelDetails: this.cancelationDetails
        };
        const verifyOtpResult = await this.mortgagesService.VerifyOTP(verifyRequest);

        const destArr: [string, string, string, string, string, number, number] = Object.values(verifyOtpResult) as [string, string, string, string, string, number, number]
        const [verifyResponse, firstname, familyName, birthDate, username, nationalityId, gender] = destArr
        const verifiedResponseObj = JSON.parse(verifyResponse)

        //console.log(typeof firstname, typeof familyName, 'res')
        //console.log(verifiedResponseObj.result, 'verifiedResponseObj.result');

        if (verifyOtpResult) {
            if (verifyOtpResult.isError) {
                Toaster.error(verifyOtpResult.responseException, 'حدث خطا اثناء التحقق يرجى المحاولة في وقت آخر');
            }
            else {
                this.openCloseDialog = false;
                this.messageAlert = 'done'



                if (!this.isAnnoymousUser) {
                    window.scrollTo(0, 0);

                    if (await this.setQaimConfig()) {
                        const num = String(birthDate);
                        const days = num.substring(0, 2);
                        const months = num.substring(2, 4);
                        const years = num.substring(4);
                        this.openCloseDialog = false;
                        this.messageAlert = 'done';
                        this.QaimHeader = 'نرجو التكرم بتقييم خدمة اعتماد طلب رهن أعيان شاكرين لك تعاونك الذي بدوره سيساعدنا على التطوير';
                        this.QaimFooter = 'نشكر لكم مساهمتكم في تطوير الخدمات العدلية';
                        this.QaimFirstName = firstname;
                        this.QaimLastName = familyName;
                        this.QaimBirthDate = `${days}/${months}/${years}`;
                        this.QaimNationalityNumber = username;
                        this.QaimNationalityId = nationalityId;
                        this.QaimusrGender = gender;
                        this.QaimresponseSentToUrl = verifiedResponseObj.result;
                        this.alertText = `${verifiedResponseObj.result}`;
                        this.objResult = verifiedResponseObj.result;
                        this.ShowQaim = true;
                    }




                }
                if (this.isAnnoymousUser) {
                    window.scrollTo(0, 0);
                    //this.alertText = `${verifyOtpResult.result}`
                    this.alertText = `${verifiedResponseObj.result}`


                    this.requestFinished = true;

                }

            }
        }
        this.verifyclick = this.verifyclick + 1;
    }

    public async NafathVerifyOTP(isPolling = false): Promise<VerifyResult> {
        if (this.verifyclick === 2) this.disableResend = false;

        // Step 1: when external+polling we send CheckStatus, otherwise real action
        const decisionUsed = (this.isAnnoymousUser && isPolling) ? 'CheckStatus' : (this.openStep || 'ApproveMortgages');

        const baseRequest = {
            otp: this.otpCode,
            Decision: decisionUsed,
            encId: this.eId,
            encKey: this.eKey,
            encIdNo: String(this.eIdNo).trim(),
            MortgageId: String(this.dataItem.MortgageRequestId),
            cancelReason: this.selectedCancellationReason,
            cancelDetails: this.cancelationDetails
        };

        try {
            const first = await this.mortgagesService.NafathVerifyOTP(baseRequest);

            // ---- parse item1 (may be JSON string or text) ----
            const raw = first && first.item1 ? first.item1 : null;
            let env: any = null;
            let text: string | null = null;

            if (typeof raw === 'string') {
                const s = raw.trim();
                if (s.startsWith('{') || s.startsWith('[')) {
                    try { env = JSON.parse(s); } catch { text = s; }
                } else {
                    text = s;
                }
            } else {
                env = raw;
            }

            // helper to normalize any status string
            const norm = (v: any) => {
                const s = String(v || '').toUpperCase().replace(/[^\w]/g, '');
                if (['OK', 'VERIFIED', 'SUCCESS', 'ACCEPTED', 'APPROVED'].includes(s)) return 'OK';
                if (['WAITING', 'PENDING'].includes(s)) return 'WAITING';
                if (['EXPIRED', 'TIMEOUT', 'TIMEDOUT'].includes(s)) return 'EXPIRED';
                if (['REJECTED', 'DENIED', 'CANCELLED', 'CANCELED'].includes(s)) return 'REJECTED';
                return s || 'WAITING';
            };

            // translate explicit error envelopes
            if (env && env.isError === true) {
                const st = norm(env.responseException);
                if (st === 'WAITING') return { success: false, state: 'WAITING', message: 'الرجاء فتح تطبيق نفاذ وتأكيد الطلب' };
                if (st === 'EXPIRED') { this.timeToExpire = '0'; this.disableResend = false; this.nafathErrorMessage = 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ'; return { success: false, state: 'EXPIRED', message: this.nafathErrorMessage }; }
                if (st === 'REJECTED') { this.nafathErrorMessage = 'تم رفض الطلب من خلال تطبيق نفاذ'; return { success: false, state: 'ERROR', message: this.nafathErrorMessage }; }
                this.nafathErrorMessage = env.responseException || 'حدث خطأ ما نرجو المحاولة مرة أخرى';
                return { success: false, state: 'ERROR', message: this.nafathErrorMessage };
            }

            // derive status from success envelope or plain text
            const statusRaw = text
                ? text
                : (env && env.result && env.result.nafathstatus) ? env.result.nafathstatus
                    : (env && env.message) ? env.message : '';
            const status = norm(statusRaw);

            // ---- POLLING branch (anonymous CheckStatus) ----
            if (decisionUsed === 'CheckStatus') {
                if (status === 'WAITING') return { success: false, state: 'WAITING', message: 'الرجاء فتح تطبيق نفاذ وتأكيد الطلب' };
                if (status === 'EXPIRED') { this.timeToExpire = '0'; this.disableResend = false; this.nafathErrorMessage = 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ'; return { success: false, state: 'EXPIRED', message: this.nafathErrorMessage }; }
                if (status === 'REJECTED') { this.nafathErrorMessage = 'تم رفض الطلب من خلال تطبيق نفاذ'; return { success: false, state: 'ERROR', message: this.nafathErrorMessage }; }

                //  VERIFIED → do the FINAL COMMIT call with the real action
                if (status === 'OK') {
                    // map to backend action: RejectMortgages => 3 else 2 (approve)
                    const finalDecision = (this.openStep === 'RejectMortgages') ? 'RejectMortgages' : 'ApproveMortgages';
                    const finalReq = { ...baseRequest, Decision: finalDecision };

                    const finalRes = await this.mortgagesService.NafathVerifyOTP(finalReq);
                    // parse final result envelope same way
                    const fraw = finalRes && finalRes.item1 ? finalRes.item1 : null;
                    let fenv: any = null;
                    if (typeof fraw === 'string') {
                        try { fenv = JSON.parse(fraw); } catch { fenv = { result: fraw }; }
                    } else {
                        fenv = fraw;
                    }

                    if (fenv && fenv.isError === true) {
                        const st2 = norm(fenv.responseException);
                        if (st2 === 'EXPIRED') { this.timeToExpire = '0'; this.disableResend = false; this.nafathErrorMessage = 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ'; return { success: false, state: 'EXPIRED', message: this.nafathErrorMessage }; }
                        if (st2 === 'REJECTED') { this.nafathErrorMessage = 'تم رفض الطلب من خلال تطبيق نفاذ'; return { success: false, state: 'ERROR', message: this.nafathErrorMessage }; }
                        this.nafathErrorMessage = fenv.responseException || 'حدث خطأ ما نرجو المحاولة مرة أخرى';
                        return { success: false, state: 'ERROR', message: this.nafathErrorMessage };
                    }

                    // success commit → close UI, mark finished
                    this.nafathErrorMessage = '';
                    this.openCloseDialog = false;
                    this.requestFinished = true;
                    this.verifyclick += 1;

                    // capture objResult if backend returns an id/string
                    //if (fenv && typeof fenv.result === 'string') this.objResult = fenv.result;
                    // capture objResult
                    if (fenv) {
                        if (typeof fenv.result === 'string') {
                            this.objResult = fenv.result;
                        } else if (fenv.result && typeof fenv.result === 'object') {
                            const r: any = fenv.result;
                            this.objResult = String(r.requestId || r.reqId || r.reference || r.result || this.objResult || '');
                        }
                    }

                    // tst

                    this.messageAlert = 'done';
                    this.alertText = String(
                        this.objResult ||
                        (fenv && typeof fenv.result === 'string' ? fenv.result : 'تمت العملية بنجاح')
                    );
                    // Optional toast:
                    // Toaster.success('تمت العملية بنجاح');

                    // Optional: redirect only if you have a reference id
                    if (this.objResult) {
                        this.redirectToResultPage();
                    }




                    return { success: true, state: 'OK' };
                }

                // polling
                return { success: false, state: 'WAITING', message: 'الرجاء فتح تطبيق نفاذ وتأكيد الطلب' };
            }

            // ---- NON-polling branch (internal or explicit action) ----
            if (status === 'WAITING') return { success: false, state: 'WAITING', message: 'الرجاء فتح تطبيق نفاذ وتأكيد الطلب' };
            if (status === 'EXPIRED') { this.timeToExpire = '0'; this.disableResend = false; this.nafathErrorMessage = 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ'; return { success: false, state: 'EXPIRED', message: this.nafathErrorMessage }; }
            if (status === 'REJECTED') { this.nafathErrorMessage = 'تم رفض الطلب من خلال تطبيق نفاذ'; return { success: false, state: 'ERROR', message: this.nafathErrorMessage }; }

            // success
            this.nafathErrorMessage = '';
            this.openCloseDialog = false;
            this.messageAlert = 'done';
            this.verifyclick += 1;

            if (this.isAnnoymousUser) {
                this.requestFinished = true;
            } else {
                // (internal) 
            }


            if (env) {
                if (typeof env.result === 'string') {
                    this.objResult = env.result;
                } else if (env.result && typeof env.result === 'object') {
                    const r: any = env.result;
                    this.objResult = String(
                        r.requestId || r.reqId || r.reference || r.result || this.objResult || ''
                    );
                }
            }


            this.alertText = String(
                this.objResult ||
                (env && typeof env.result === 'string' ? env.result : 'تمت العملية بنجاح')
            );


            return { success: true, state: 'OK' };

        } catch (e) {
            console.error('NafathVerifyOTP error:', e);
            this.nafathErrorMessage = 'فشل الاتصال بالخادم';
            return { success: false, state: 'ERROR', message: this.nafathErrorMessage };
        }
    }




    private redirectToResultPage() {
        this.openStep === 'RejectMortgages'
            ? this.$router.push(`/list/${this.objResult}R`)
            : this.$router.push(`/list/${this.objResult}A`);
    }



    public getLogStatusColor(status: any) {
        let color = ''
        switch (status) {
            case 2: {
                color = '#158e8d'
                break;
            }
            case 10: {
                color = '#ffc107'
                break;
            }
            case 3: {
                color = '#dc3545'
                break;
            }

            default:
                color = 'black'
                break;
        }
        return color
    }

    public getStatusColor(status: number) {

        let color = 'black';
        if (status == 3)
            return 'green';
        else if (status == 4)
            return 'red';
        else if (status == 2)
            return 'navy';
        else if (status == 6)
            return 'gray';
        return color;
    }
    public get PrintButton() {
        if (this.dataItem.Status == 3 || this.dataItem.Status == 6)
            return this.viewButton = true;
    }
    public async DawnLodePDF() {

        await this.mortgagesService.DawnLodePDF(this.dataItem.DocumentNumber);

    }


    public async resendOTP() {
        this.disableResend = true;

        const aproveData = {
            Key: this.eKey,
            /*     IdNo: String(this.eIdNo).trim(),*/
            IdNo: String(encodeURIComponent(this.eIdNo)).trim(),
            Id: this.eId,
            MortgageId: String(this.dataItem.MortgageRequestId)
        };

        try {
            const otpResponse = this.IsNafathAuthenticationEnabled
                ? await this.mortgagesService.NafathGenerateOtp(aproveData)
                : await this.mortgagesService.GenerateOtp(aproveData);

            if (!otpResponse || (otpResponse.isError && otpResponse.isError === true)) {
                Toaster.error(
                    (otpResponse && otpResponse.responseException)
                        ? otpResponse.responseException
                        : 'تعذر إرسال رمز التحقق'
                );
                this.disableResend = false;
                return;
            }

            // Reset shared dialog state
            this.openCloseDialog = true;
            this.showCancellationReasonDiv = false;
            this.nafathErrorMessage = '';

            if (this.IsNafathAuthenticationEnabled) {
                // --- Nafath path ---
                this.showNafathDiv = true;
                this.showOTPDiv = false;

                this.nafathCode = (otpResponse && otpResponse.result && otpResponse.result.random)
                    ? Number(otpResponse.result.random)
                    : 0;

                this.stopPolling();
                this.startPollingNafathVerifyOTP();


                setTimeout(() => { this.disableResend = false; }, 120000);

            } else {
                // --- OTP path ---
                this.showNafathDiv = false;
                this.showOTPDiv = true;

                this.otpCode = '';
                this.otpExpirationTime = new Date().getTime() + 2 * 60 * 1000;
                this.runOTPExpirationTimer();

                setTimeout(() => { this.disableResend = false; }, 120000);

                this.$nextTick(() => {
                    const ref: any = (this.$refs as any).txtOtpCode;
                    if (ref && typeof ref.focus === 'function') ref.focus();
                });
            }
        } catch (err) {
            console.error('resendOTP error:', err);
            Toaster.error('فشل الاتصال بالخادم');
            this.disableResend = false;
        }
    }


    public runOTPExpirationTimer() {
        if (this.otpExpireTimer) clearInterval(this.otpExpireTimer);
        this.otpExpireTimer = setInterval(() => this.countDownOTPExpiry(), 1000);
    }

    public countDownOTPExpiry() {
        let diff = this.otpExpirationTime - new Date().getTime();//new Date(new Date().getTime() + 3 * 60000).getTime() - new Date().getTime();
        let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((diff % (1000 * 60)) / 1000);
        this.timeToExpire = this.$t('mortgages.mortgage.time', [String(minutes).padStart(2, '0'), seconds]).toString();

        if (diff < 0) {
            clearInterval(this.otpExpireTimer);
            this.timeToExpire = '0';
        }
    }
    public async verifyOnEnter(evt: KeyboardEvent) {
        if (evt.keyCode === 13)
            await this.VerifyOTP();
    }

    public async setQaimConfig() {

        var qaimSettings = await this.mortgagesService.GetQaimSettings();


        this.QaimConfig = {

            enableRecaptcha: qaimSettings.enableRecaptcha,
            apiUrl: qaimSettings.apiUrl,
            googleRecaptchaSiteKey: qaimSettings.googleRecaptchaSiteKey
        }
        this.QaimSurveyID = qaimSettings.surveyID;
        /*   console.log(qaimSettings.result);*/
        return true;
    }


    public async GetNafathSettings(): Promise<boolean> {
        const settings: any = await this.mortgagesService.GetNafathSettings();

        // Normalize to a real boolean without ?? or ?.
        let enabled = false;
        if (settings && typeof settings === 'object') {
            if (Object.prototype.hasOwnProperty.call(settings, 'isNafathAuthenticationEnabled')) {
                enabled = !!settings.isNafathAuthenticationEnabled;
            } else if (Object.prototype.hasOwnProperty.call(settings, 'IsNafathAuthenticationEnabled')) {
                enabled = !!settings.IsNafathAuthenticationEnabled;
            } else if (Object.prototype.hasOwnProperty.call(settings, 'enabled')) {
                enabled = !!settings.enabled;
            } else {

                enabled = !!settings;
            }
        } else {

            enabled = !!settings;
        }

        this.IsNafathAuthenticationEnabled = enabled; // store only a boolean
        return enabled;
    }




    public startPollingNafathVerifyOTP() {
        // allow polling for internal too
        if (this.isPollingActive) return;
        this.isPollingActive = true;

        if (this.pollingStartTimeout) { clearTimeout(this.pollingStartTimeout); this.pollingStartTimeout = null; }
        if (this.pollingInterval) { clearInterval(this.pollingInterval); this.pollingInterval = null; }

        this.pollingStartTimeout = setTimeout(() => {
            this.pollingStartTimeout = null;
            this.pollNafathVerifyOTP(); // first call after 5s
            this.pollingInterval = setInterval(() => this.pollNafathVerifyOTP(), 5000);
        }, 5000);
    }


    private async pollNafathVerifyOTP() {
        try {

            const r = await this.NafathVerifyOTP(true);

            switch (r.state) {
                case 'WAITING':
                    this.nafathErrorMessage = '';
                    break;
                case 'OK':
                    this.stopPolling();
                    this.requestFinished = true;
                    this.openCloseDialog = false;


                    this.messageAlert = 'done';
                    this.alertText = String(this.objResult || 'تمت العملية بنجاح');

                    this.nafathErrorMessage = '';
                    Toaster.success(this.objResult);
                    if (this.objResult) this.redirectToResultPage();
                    break;
                case 'EXPIRED':
                    this.stopPolling();
                    this.nafathErrorMessage = r.message || 'انتهت فترة صلاحية طلب التحقق في تطبيق نفاذ';
                    this.openCloseDialog = true;
                    break;
                case 'ERROR':
                default:
                    this.stopPolling();
                    this.nafathErrorMessage = r.message || 'حدث خطأ أثناء التحقق';
                    this.openCloseDialog = true;
                    break;
            }
        } catch (e) {
            console.error('Error while polling NafathVerifyOTP', e);
            this.stopPolling();
            this.nafathErrorMessage = 'فشل الاتصال بالخادم';
        }
    }



    public CloseQaimEvent() {
        this.openStep === 'RejectMortgages' ? this.$router.push(`/list/${this.objResult}R`) : this.$router.push(`/list/${this.objResult}A`);
    }

    public cancelNafath() {
        this.stopPolling();
        this.showNafathDiv = false;
        this.openCloseDialog = false;
        this.nafathErrorMessage = '';
    }



    private stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
        if (this.pollingStartTimeout) {
            clearTimeout(this.pollingStartTimeout);
            this.pollingStartTimeout = null;
        }
        this.isPollingActive = false;
    }

    private normalizeNafathStatus(raw: any): string {
        // Uppercase, strip non-word chars (., spaces, etc.)
        const s = String(raw || '')
            .toUpperCase()
            .replace(/[^\w]/g, '') // removes punctuation  '.'
            .trim();

        // Map common synonyms to OK
        const okSynonyms = new Set(['OK', 'VERIFIED', 'SUCCESS', 'ACCEPTED', 'APPROVED', 'CONFIRMED', 'AUTHORIZED']);
        if (okSynonyms.has(s)) return 'OK';

        // Common pending/negative states
        if (s === 'WAITING' || s === 'PENDING') return 'WAITING';
        if (s === 'EXPIRED' || s === 'TIMEOUT') return 'EXPIRED';
        if (s === 'REJECTED' || s === 'DENIED' || s === 'CANCELLED' || s === 'CANCELED') return 'REJECTED';

        return s;
    }





}
